import { ElementType, TaskFormElement } from '@crm/types'
import { Rule } from 'antd/es/form'

const generic = (
  element: ElementType,
  name: string,
  label: string,
  props: Record<string, unknown>
): TaskFormElement => ({
  type: element,
  name: name,
  label: label,
  props: props
})

export const input_text = (
  name: string,
  label: string,
  rule: Rule = {}
): TaskFormElement => generic(ElementType.INPUT, name, label, { rule })

export const input_date = (
  name: string,
  label: string,
  rule: Rule = {}
): TaskFormElement => generic(ElementType.DATE, name, label, { rule })

export const input_datetime = (
  name: string,
  label: string,
  rule: Rule = {}
): TaskFormElement => generic(ElementType.DATETIME, name, label, { rule })

export const input_radio = (
  name: string,
  label: string,
  options: Array<{ value: string; text: string }>,
  rule: Rule = {}
): TaskFormElement =>
  generic(ElementType.RADIO, name, label, {
    options,
    rule
  })

export const input_checkbox = (
  name: string,
  label: string,
  rule: Rule = {}
): TaskFormElement =>
  generic(ElementType.CHECKBOX, name, label, {
    rule
  })

export const input_select = (
  name: string,
  label: string,
  options?: Array<{ value: string; text: string; type?: string }>,
  api?: string,
  rule: Rule = {},
  required = true
): TaskFormElement =>
  generic(ElementType.SELECT, name, label, {
    options,
    api,
    rule,
    required
  })

export const input_operator = (
  name: string,
  label: string,
  options?: Record<string, unknown>,
  api?: string,
  rule: Rule | null = null,
  required = true
): TaskFormElement =>
  generic(ElementType.OPERATOR, name, label, {
    options,
    api,
    rule,
    required
  })

export const input_value = (
  name: string,
  label: string,
  options?: Record<string, unknown>,
  api?: string,
  rule: Rule | null = null,
  required = true
): TaskFormElement =>
  generic(ElementType.VALUE, name, label, {
    options,
    api,
    rule,
    required
  })
